module.exports = __webpack_public_path__ + "static/media/8ab11480-5d46-4420-91d1-7ab5df04527e.668baf93.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/8ab11480-5d46-4420-91d1-7ab5df04527e.jpg
// module id = 834
// module chunks = 0